import { StaticPropsComponentExtensions } from '@shared/feature/component-static-extensions';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConfig, ProductionTypes } from '@shared/utils/app-config';
import { passwordMatchingValidator } from '@shared/feature/forms';
import { TIME_ZONES } from '@shared/utils/time-zones';
import { PhoneInputComponent, SelectOption } from '@shared/ui/inputs';
import { ActivatedRoute } from '@angular/router';
import { VerificationCodeRequest, RegisterGuestRequest } from '../../models/request.models';
import { PageLayoutApiService } from '../../services/page-layout/page-layout-api.service';
import { PageLayoutModalService } from '../../services/page-layout/page-layout-modal.service';
import { Patterns } from '@shared/utils/patterns';
import { AccountTypes } from '@shared/utils/base-auth';

@Component({
  selector: 'feature-page-layout-register-guest',
  templateUrl: './register-guest.component.html',
  styleUrls: ['./register-guest.component.css'],
  standalone: false,
})
export class RegisterGuestComponent extends StaticPropsComponentExtensions implements OnInit {
  @ViewChild(PhoneInputComponent) phoneInput?: PhoneInputComponent;

  userUid: string | null = null;
  fileUid: string | null = null;
  email: string | null = null;
  date = new Date();

  formGroup: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    lastName: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    phoneNumber: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
    timezone: new FormControl('', [Validators.required, Validators.maxLength(250)]),
    password: new FormGroup(
      {
        password: new FormControl('', [Validators.required, Validators.maxLength(16), Validators.minLength(8), Validators.pattern(Patterns.Password)]),
        confirmPassword: new FormControl('', [Validators.required, Validators.maxLength(16), Validators.minLength(8), Validators.pattern(Patterns.Password)]),
      },
      { validators: passwordMatchingValidator() }
    ),
  });

  timeZonesOptions: SelectOption[] = [];

  constructor(
    public appConfig: AppConfig,
    private route: ActivatedRoute,
    private pageLayoutModalService: PageLayoutModalService,
    private verificationApiService: PageLayoutApiService
  ) {
    super();
    this.timeZonesOptions = TIME_ZONES.map((x) => new SelectOption(x.displayName, x.value));
  }

  ngOnInit(): void {
    this.userUid = this.route.snapshot.queryParamMap.get('userUid');
    this.fileUid = this.route.snapshot.queryParamMap.get('fileUid');
    this.email = this.route.snapshot.queryParamMap.get('email');
  }

  onRegister(): void {
    if (!this.phoneInput || !this.userUid) {
      return;
    }

    const phoneNumber = this.phoneInput.getNumber();

    if (!phoneNumber || !this.phoneInput.isNumberValid()) {
      return;
    }

    const request = new RegisterGuestRequest(
      this.formGroup.get('firstName')?.value,
      this.formGroup.get('lastName')?.value,
      this.formGroup.get('timezone')?.value,
      this.formGroup.get('password.password')?.value,
      phoneNumber,
      this.appConfig.productionType === ProductionTypes.isIndustrialCam ? AccountTypes.Social : AccountTypes.Local
    );

    this.verificationApiService.sendVerificationRequest(this.userUid, new VerificationCodeRequest(phoneNumber)).subscribe(() => {
      this.pageLayoutModalService.openVerifyPhoneNumber(request, phoneNumber, this.userUid ?? '');
    });
  }
}
